import { useMessageTemplatesState } from 'hooks/messageTemplates/useMessageTemplatesState';

export const useEditetMessageTemplate = (id: number) => {
  const { changedTemplates } = useMessageTemplatesState();

  return changedTemplates.find(template => template.id === id);
};
